export default "__VITE_ASSET__CIRDUuVJ__"